module.exports = __webpack_public_path__ + "img/document.526d4bb9.png";